import { FunctionComponent, useEffect } from 'react';
import L from 'leaflet'
import 'leaflet/dist/leaflet.css';

interface Props {
    latitude: number;
    longitude: number;
}

const Map: FunctionComponent<Props> = ({latitude, longitude}) => {
    useEffect(() => {
        let map = L.map('map').setView([latitude ?? 51.9691868, longitude ?? 5.6653948], 13);
        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 18,
        id: 'mapbox/streets-v11',
        tileSize: 512,
        zoomOffset: -1,
        accessToken: process.env.REACT_APP_MAP_KEY
        } as L.TileLayerOptions).addTo(map);

        return () => {
            map.off();
            map.remove()
        };
    }, [latitude, longitude]);

    return (
        <div id='map' className='university-slider__map'></div>
    );
};

export default Map;
